import branchService from "../../../services/branch/BranchService.js";
import i18n from '../../../i18n/index'

export default {
    data() {
        return {
            count: 0,
            search: "",
            lengthServer: 0,
            pagination: {},
            branches: [],
            headers: [
                {
                    text: i18n.t('headers.name'),
                    sortable: false,
                    value: "name"
                },
                {
                    text: 'CADENA',
                    sortable: false,
                    value: "providerId"
                },
                // {
                //     text: i18n.t('headers.type'),
                //     sortable: false,
                //     value: "type"
                // },
                {
                    text: 'ESTADO',
                    sortable: false,
                    value: "active"
                },
                // {
                //     text: 'FARMACIA UNIFICADA',
                //     sortable: false,
                //     value: "unifiedPharmacy"
                // }
            ]
        };
    },
    props: { onRowClick: { type: Function, default: () => { } } },
    watch: {
        pagination: {
            handler() {
                this.getBranches();
            },
            deep: true
        }
    },
    methods: {
        update(item) {
            this.$emit('update', item)
        },
        
        getBranches(){
            const { page, rowsPerPage } = this.pagination;
            branchService.searchBranche(page - 1, rowsPerPage, this.search).then(response => {
                this.branches = response.data[0];
                this.lengthServer = parseInt(response.data[1])
            });
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase()
            return items.filter(row => filter(row["name"], search));
        }
    }
}